module.exports = __webpack_public_path__ + "img/imgImgHome11.82500977.svg";